// Put your application javascript here
if (Cookies().currency_chosen != 'true') {
    getGeolocation(handleIPGeolocationResponse, '981cfd6438884e0b869d645e61292193');

    function handleIPGeolocationResponse(location) {
        let user_currency = location.currency.code;
        if (Cookies().cart_currency != user_currency) {
            if($('.disclosure-list__option[data-value="' + user_currency + '"]')[0] == null) {
                user_currency = "USD";
            }
            $('.disclosure-list__option[data-value="' + user_currency + '"]')[0].dispatchEvent(new Event('click'));
        }
    }
}